import { generateApiRoute } from '@klp/core/api/helpers';

const clientApiName = 'kunde';

export const clientApiRoutes = {
    getKunder: () => generateApiRoute([clientApiName]),
};
